// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yfX0E4RXf09p1O {
  display: block;
  position: relative;
  width: 24px;
  height: 24px;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
.yfX0E4RXf09p1O span {
  display: block;
  position: absolute;
  left: var(--ds-space-0, 0);
  width: 24px;
  height: 3px;
  transform: rotate(0deg);
  transition: 0.3s ease;
  border-radius: 3px;
  opacity: 1;
  background-color: var(--ds-background-neutral-bold, #44546f);
}
@media (prefers-reduced-motion: reduce) {
  .yfX0E4RXf09p1O span {
    transition: none;
  }
}
.yfX0E4RXf09p1O.mRyH6UZ9_vccXn span:nth-child(1) {
  top: 10.5px;
  left: var(--ds-space-0, 0px);
  transform: rotate(45deg);
}
.yfX0E4RXf09p1O.mRyH6UZ9_vccXn span:nth-child(2) {
  top: 10.5px;
  width: 0%;
  opacity: 0;
}
.yfX0E4RXf09p1O.mRyH6UZ9_vccXn span:nth-child(3) {
  top: 10.5px;
  left: var(--ds-space-0, 0px);
  transform: rotate(-45deg);
}
.yfX0E4RXf09p1O:not(.mRyH6UZ9_vccXn) span:nth-child(1) {
  top: 1.5px;
  transform-origin: left center;
}
.yfX0E4RXf09p1O:not(.mRyH6UZ9_vccXn) span:nth-child(2) {
  top: 10.5px;
  transform-origin: left center;
}
.yfX0E4RXf09p1O:not(.mRyH6UZ9_vccXn) span:nth-child(3) {
  top: 19.5px;
  transform-origin: left center;
}
`, ""]);
// Exports
export var menuIcon = `yfX0E4RXf09p1O`;
export var isOpen = `mRyH6UZ9_vccXn`;
export default ___CSS_LOADER_EXPORT___;
